import { EulerOrder, type Bone, type EulerOrderSource } from '../skeleton/core';

const FBX_DCC_ORDER_BY_INTERNAL: Record<EulerOrder, EulerOrder> = {
  xyz: EulerOrder.ZYX,
  xzy: EulerOrder.YZX,
  yxz: EulerOrder.ZXY,
  yzx: EulerOrder.XZY,
  zxy: EulerOrder.YXZ,
  zyx: EulerOrder.XYZ,
};

/**
 * FBXLoader stores an intrinsic order derived from FBX extrinsic order.
 * For DCC-facing labels in UI, invert that mapping when the order comes
 * from transformData metadata.
 */
export function toDccFacingEulerOrder(
  internalOrder: EulerOrder,
  source: EulerOrderSource,
): EulerOrder {
  if (source !== 'transformData') return internalOrder;
  return FBX_DCC_ORDER_BY_INTERNAL[internalOrder] ?? internalOrder;
}

export function toDccFacingEulerOrderLabel(
  internalOrder: EulerOrder,
  source: EulerOrderSource,
): string {
  return toDccFacingEulerOrder(internalOrder, source).toUpperCase();
}

export function getBoneDccFacingEulerOrderLabel(
  bone: Pick<Bone, 'eulerOrder' | 'eulerOrderSource'>,
): string {
  return toDccFacingEulerOrderLabel(bone.eulerOrder, bone.eulerOrderSource);
}
